import "./articlePage.scss";
import Wrapper from "../../components/wrapper/Wrapper";
import Aside from "../../components/aside/Aside";
import Social from "../../components/social/Social";
import Search from "../../components/search/Search";
import { useContext, useEffect, useState } from "react";
import { getPostBySlug } from "../../dataProvider/posts";
import { getCategoryByID } from "../../dataProvider/category";
import { sendEvent } from "../../dataProvider/googleTagManager";
import { Link, useLocation } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import ArticleTitle from "../../components/articleTitle/ArticleTitle";
import { I18nContext } from "../../i18n";
import AdComponent from "../../components/adComponents/AdComponent";
import truncate from "../../helpers/truncate";
import useIsScreenSize from "../../hooks/useIsScreenSize";
import ScrollTop from "../../components/scrollTop/ScrollTop";
import Reviews from "../../components/reviews/Reviews";
import Fader from "../../components/fader/Fader";

const ArticlePage = () => {
  const { translate, langCode } = useContext(I18nContext);
  const { setCategorySelected, tags, currentLanguage, currentTag } = useContext(AppContext);
  const [article, setArticle] = useState({});
  const [articleCategory, setArticleCategory] = useState();
  const location = useLocation();
  const isMobile = useIsScreenSize(940);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    console.log("run");
    if (currentTag !== undefined && currentTag?.length !== 0) {
      const slug = location.pathname.split("/")[3];
      getPostBySlug(slug, currentTag)
        .then((res) => {
          setArticle(res?.[0]);

          const events = res?.[0].metadata?.events || [];
          events.forEach((event) => sendEvent(event));

          return res[0];
        })
        .then((res) => getCategoryByID(res?.categories[0]))
        .then((res) => {
          setArticleCategory(res);
          setCategorySelected(res);
        })
        .catch((er) => console.error(er));
    }
  }, [location.pathname, setCategorySelected, currentLanguage, tags, currentTag]);

  return (
    <div className="article-page">
      <Wrapper>
        <div className="article-page__ad">
          <AdComponent className="ad-full-width-rectangle" />
        </div>
        <div className="article-page__main">
          <div className="article-page__container">
            <section className="article-page__content">
              <nav className="article-page__nav">
                <Link to="/">
                  <Fader tag="p" text={translate("categoryPage").navHome} arrow={true} />
                </Link>
                <Link to={`/${langCode}/category/${articleCategory?.slug}`}>
                  <Fader tag="p" text={articleCategory?.name} arrow={true} />
                </Link>
                <Fader tag="p" text={truncate(article?.title?.rendered, 30)} />
              </nav>

              {article?.length !== 0 && (
                <ArticleTitle text={article?.title?.rendered} titleClass={"article-page__title"} />
              )}
              <div
                className="article-page__description"
                dangerouslySetInnerHTML={{ __html: article?.content?.rendered }}
              />
              <div className="article-page__ad ads"></div>
            </section>
            <Aside otherCategory={true} topPub={true} seeAsWell={true} />
          </div>
          <div className="article-page__banner">
            <div className="article-page__banner-container">
              <Social />
              <Search open={true} />
            </div>
          </div>
          <Reviews article={article} />
        </div>
        <div className="article-page__ad">
          <AdComponent className="ad-full-width-rectangle" />
        </div>
      </Wrapper>
      {!isMobile && <ScrollTop />}
    </div>
  );
};

export default ArticlePage;
